import { render } from "./FormButton.vue?vue&type=template&id=45cf4510&scoped=true"
import script from "./FormButton.vue?vue&type=script&lang=js"
export * from "./FormButton.vue?vue&type=script&lang=js"

import "./FormButton.vue?vue&type=style&index=0&id=45cf4510&scoped=true&lang=css"

import exportComponent from "/Users/zayed-lune/Desktop/Lunedata/lune-dashboard/dashboard-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45cf4510"],['__file',"src/components/helpers/FormButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "45cf4510"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('45cf4510', __exports__)) {
    console.log('reload')
    api.reload('45cf4510', __exports__)
  }
  
  module.hot.accept("./FormButton.vue?vue&type=template&id=45cf4510&scoped=true", () => {
    console.log('re-render')
    api.rerender('45cf4510', render)
  })

}


export default __exports__